import { useState } from "react";
import { Sparkles } from "lucide-react";
// import { Input } from "./misc/input";
// import Button from "../../components/elements/forms/Button2";
import Landing from "../../themes";

export function AIRecruiter() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (email) {
      setIsSubmitted(true);
      setTimeout(() => {
        setEmail("");
        setIsSubmitted(false);
      }, 3000);
    }
  };

  return (
    <Landing>
      <div className="font-abel relative min-h-[550px] flex items-center justify-center px-4 overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50" />

        {/* Animated background elements */}
        <div className="absolute inset-0 overflow-hidden">
          <div className="absolute top-20 left-10 w-72 h-72 bg-blue-400/20 rounded-full blur-3xl animate-pulse" />
          <div
            className="absolute bottom-20 right-10 w-96 h-96 bg-purple-400/20 rounded-full blur-3xl animate-pulse"
            style={{ animationDelay: "1s" }}
          />
        </div>

        {/* Content */}
        <div className="relative z-10 max-w-4xl mx-auto text-center">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/80 backdrop-blur-sm rounded-full border border-indigo-200 mb-8 shadow-sm">
            <Sparkles className="w-4 h-4 text-[#243677]" />
            <span className="text-[#243677]">AI-Powered Recruitment</span>
          </div>

          {/* Main heading */}
          <h1 className="text-5xl md:text-7xl mb-6 bg-gradient-to-r from-[#243677] via-[#51A4FF] to-[#036CFF] bg-clip-text text-[transparent]">
            Coming Soon
          </h1>

          {/* Subheading */}
          <h2 className="text-3xl md:text-4xl mb-4 text-gray-900">
            25th and Staffing AI Recruiter
          </h2>

          <p className="text-xl text-gray-600 mb-12 max-w-2xl mx-auto">
            The future of intelligent recruitment is here. Get ready to
            transform your hiring process with cutting-edge AI technology.
          </p>

          {/* Email signup form */}
          {/* <form onSubmit={handleSubmit} className="max-w-md mx-auto mb-8">
            <div className="flex flex-col sm:flex-row gap-3">
              <Input
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                className="flex-1 h-12 px-6 bg-white/90 backdrop-blur-sm border-gray-300 focus:border-indigo-500 focus:ring-indigo-500"
              />
              <Button
                title="Notify Me"
                onSubmitHandler={() => {}}
                type="submit"
                className="h-12 px-8 bg-gradient-to-r from-[#243677] to-[#51A4FF] hover:from-indigo-700 hover:to-purple-700"
              />
            </div>
            {isSubmitted && (
              <p className="mt-3 text-green-600">
                Thanks! We'll notify you when we launch.
              </p>
            )}
          </form> */}

          {/* Launch date */}
          {/* <p className="text-gray-500">
            Launching on the <span className="text-[#243677]">25th</span>
          </p> */}
        </div>
      </div>
    </Landing>
  );
}
